import { useMemo } from "react";
import { Product } from "@/services/productService";

const useProductDefaultStyledAttributes = (product: Product) => {
  return useMemo(() => {
    const highlights = product?.highlights;
    if (!highlights) {
      return {};
    }

    const attributesWithSpecialStyles = [
      "bullets",
      "attributes",
      "sizeShown",
      "globalShipping"
    ];
    const productDefaultStyledAttributes = {
      ...highlights
    };
    attributesWithSpecialStyles.forEach(
      key => delete productDefaultStyledAttributes[key]
    );

    return productDefaultStyledAttributes;
  }, [product?.highlights]);
};

export default useProductDefaultStyledAttributes;
